// Date helpers — extracted verbatim from partners-portal.jsx. Pure, no deps.

export const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const addMonths = (date, months) => {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
};

export const formatDate = (date) => {
  if (!date) return 'N/A';
  const normalized = typeof date === 'string' ? date.replace(' ', 'T') : date;
  return new Date(normalized).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const isDatePast = (date) => {
  return new Date(date) < new Date();
};

export const daysBetween = (date1, date2) => {
  const diff = new Date(date2) - new Date(date1);
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};
